<template>
  <div class="container_box">
    <Tabs v-model="orderTableStatus" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in stockTabList" :label="item.title" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="orderTableStatus === '0'">
            <FormItem :label="$t('key1004334')" prop="packageOrderStatusList">
              <Select v-model="pageParams.packageOrderStatusList" multiple :placeholder="$t('key1004567')">
                <Option v-for="item in stockOrderStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
            v-if="['0', '1', '2'].includes(orderTableStatus)">
            <FormItem :label="$t('key1004568')" prop="outPackageOrderStatusList">
              <Select v-model="pageParams.outPackageOrderStatusList" multiple :placeholder="$t('key1004569')">
                <Option v-for="item in deliveryOrderStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004570')" prop="outboundTypes">
              <Select v-model="pageParams.outboundTypes" multiple :placeholder="$t('key1004571')">
                <Option v-for="item in deliveryOrderTypeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownDateTime
              :transfer="false"
              ref="dropDownDateTime"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectTimeValue"
              @changeInput="changeTimeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003353')" prop="supplierMerchantIds">
              <Input type="textarea" :placeholder="$t('key1004326')"
                v-model.trim="pageParams.supplierMerchantIds"></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--导出订单-->
      <Dropdown transfer @on-click="changeExportBtn" class="mr15"
        v-if="getPermission('ymsSubPackageInfo_exportPackageInfoStockOrder')">
        <Button type="primary">
          <span>{{ $t('key1004572') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        :loading="tableLoading"
        border
        max-height="530"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1003082')"
      paramKeyColums="supplierPackageInfoOrderStockExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import Mixin from "@/components/mixin/common_mixin";
import api from "@/api";
import {pageJump, setConfigCharacters, getDataSetBatchList, getEnumList} from "@/utils/common";
import dropDownDateTime from "@/components/common/dropDownDateTime.vue";

export default {
  name: "supplierStockList",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      total: 0,
      pageParamsStatus: false,
      orderTableStatus: '0',
      pageParams: {
        packageOrderStatusList: [], // 备货单状态 1:待发货 2:已发货 21:已入库 3:已分拣(YMS已收货) 4:已取消
        outPackageOrderStatusList: [], // 出库单状态 1:待发货/待拣货 2:待包装 3:待出库 4:已出库 7:已作废 8:已装箱
        outboundTypes: [], // 出库单类型 (1:销售出库 2:自有仓备货(云卖中心仓备货) 3:三方仓备货(第三方仓备货))
        packageCodeList: '', // 备货单号
        skuList: '', //sku
        ymsSkuList: '', // ymsSkuList
        startCreatedTime: null, // 开始创建时间
        endCreatedTime: null, // 结束创建时间
        startDespatchTime: null,  // 开始发货时间
        endDespatchTime: null, // 结束发货时间
        startStorageTime: null, // 开始入库时间
        endStorageTime: null, // 结束入库时间
        startCancleTime: null, // 开始取消时间
        endCancleTime: null, // 结束取消时间
        supplierMerchantIds: '',
        pageNum: 1,
        pageSize: 15
      },
      tableData: [],
      tableColumns: [],
      stockTabList: [ // 备货单状态 1:待发货 2:已发货 21:已入库 3:已分拣(YMS已收货) 4:已取消
        {value: '0', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')},
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
        {value: '21', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004103')},
        {value: '3', title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004557')}`},
        {value: '4', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')}
      ],
      stockOrderStatusList: [
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002920')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
        {value: 21, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004103')},
        {value: 3, title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004557')}`},
        {value: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
      ],
      deliveryOrderStatusList: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'packageCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004559')},
            {paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {paramKey: 'packageOrderStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461')},
            {paramKey: 'totalStockQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004428')},
            {paramKey: 'actualSortingQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004429')},
            {paramKey: 'pickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003658')},
            {paramKey: 'outPackageOrderStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004371')},
            {paramKey: 'outboundType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004560')},
            {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159')},
            {paramKey: 'despatchTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003847')},
          ]
        }
      ],
      dropDownTimeList: [],
      defaultSelectTimeValue: 1,
      dropDownInputList: [ // 备货单号、SKU、YMSSKU
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004559'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004561'), parameterKey: 'packageCodeList'},
        {title: 'SKU', value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004114'), parameterKey: 'skuList'},
        {title: `${setConfigCharacters(false)}SKU`, value: 3, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004558')}`, parameterKey: 'ymsSkuList'}
      ],
      defaultSelectValue: 1,
      deliveryOrderStatusData: [],
      enumData: [],
    };
  },
  computed: {
    filterKeyList() {
      let parameterKeyList = this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
      return parameterKeyList;
    },
    // 出库单类型
    deliveryOrderTypeList() {
      const ENUM_KEY = 'PackageInfoOutboundTypeSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list = list.filter(item => [2, 3, 4].includes(item.value));
      return list;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      let enumKeyList = ['PackageInfoOutboundTypeSupplierEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.setDefaultTimerParams('three_months', 1);
      this.search();
    },
    // 重置数据
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.changeInput(1);
      v.changeTimeInput(1);
      v.selectTableData = [];
      v.setDefaultTimerParams('three_months', 1);
      v.getList();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.selectTableData = [];
      v.total = 0;
      v.tableData = [];
      v.optionBtnWidth = [];
      v.tableLoading = true;
      if (v.getPermission('ymsSubPackageInfo_queryForStock')) {
        v.axios.post(api.post_ymsSubPackageInfo_queryForStock, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.tableData = list;
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 切换Tab
    changeTab(name) {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.changeInput(1);
      v.changeTimeInput(1);
      v.selectTableData = [];
      v.pageParams.packageOrderStatusList = name === '0' ? [] : [Number(name)];
      v.setDefaultTimerParams('three_months', 1);
      v.pageParams.pageNum = 1;
      v.pageParamsStatus = true;
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data;
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let arr = [...v.filterKeyList, 'supplierMerchantIds'];
      let params = Object.assign({}, v.pageParams);
      for (let key in params) {
        if (arr.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.packageIds = v.selectTableData.map((item) => {
          return item.ymsSubPackageId;
        });
      } else {
        query.packageIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          v.axios.post(api.post_ymsSubPackageInfo_exportPackageInfoStockOrder, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      });
    },
    // 改变默认时间筛选下拉选项的值
    changeTimeInput(value) {
      this.defaultSelectTimeValue = value;
      this.$refs['dropDownDateTime'].timeList = [];
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 处理列表字段
    handleColumns(val) {
      let v = this;
      v.optionBtnWidth = [];
      let columns = [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          key: 'idx',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004559'),
          key: 'packageCode',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.packageCode,
                styles: {
                  justifyContent: 'flex-start'
                }
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/supplierStockOrderDetails',
                    query: {
                      ymsSubPackageId: params.row.ymsSubPackageId
                    }
                  });
                  window.open(href, '_blank');
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          align: 'left',
          minWidth: 150
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004562'),
          key: 'packageOrderStatus',
          align: 'left',
          minWidth: 140,
          render(h, params) {
            let text = '-';
            let orderStatus = params.row.packageOrderStatus;
            v.stockOrderStatusList.map((item) => {
              if (item.value === orderStatus) {
                text = item.title;
              }
            });
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004428'),
          key: 'totalStockQuantity',
          align: 'left',
          minWidth: 160
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004429'),
          key: 'actualSortingQuantity',
          align: 'left',
          minWidth: 160,
          render(h, params) {
            let actualSortingQuantity = params.row.actualSortingQuantity;
            let packageOrderStatus = params.row.packageOrderStatus; // 3 YMS已收货
            let text = packageOrderStatus === 3 ? actualSortingQuantity : '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003658'),
          key: 'pickupOrderNumber',
          align: 'left',
          minWidth: 160
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004563'),
          key: 'outPackageOrderStatus',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            let text = '-';
            let outPackageOrderStatus = params.row.outPackageOrderStatus;
            v.deliveryOrderStatusData.map((item) => {
              if (item.value === outPackageOrderStatus) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004564'),
          key: 'outboundType',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            let text = '-';
            let outboundType = params.row.outboundType;
            v.deliveryOrderTypeList.map((item) => {
              if (item.value === outboundType) {
                text = item.title;
              }
            });
            return outboundType === 4 ? h('Tooltip', {
              props: {
                transfer: true,
                maxWidth: 300,
                content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004171')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004172')}`
              },
            }, [
              h('span', {class: 'mr4'}, text),
              h('Icon', {
                props: {
                  type: 'md-help-circle',
                  size: 16
                },
                style: {
                  cursor: 'pointer'
                }
              })
            ]) : h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            return h('span', params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565'),
          key: 'shipedTime',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            return h('span', params.row.shipedTime ? v.$uDate.dealTime(params.row.shipedTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'),
          key: 'storageTime',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            return h('span', params.row.storageTime ? v.$uDate.dealTime(params.row.storageTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004566'),
          key: 'rehandleTime',
          align: 'left',
          minWidth: 170,
          render(h, params) {
            let status = params.row.status; // 99 供应商订单已作废
            if (['0', '4'].includes(v.orderTableStatus) && status === 99) {
              return h('span', params.row.updatedTime ? v.$uDate.dealTime(params.row.updatedTime, 'fulltime') : '-');
            } else {
              return h('span', '-');
            }
          }
        }
      ];
      // 1:待发货 2:已发货 21:已入库 3:已分拣(YMS已收货) 4:已取消

      let newColumns = [];
      let hideKeyList = [];
      let obj = {
        '1': ['actualSortingQuantity', 'pickupOrderNumber', 'despatchTime', 'storageTime', 'rehandleTime'],
        '2': ['actualSortingQuantity', 'storageTime', 'rehandleTime'],
        '21': ['rehandleTime'],
        '3': ['rehandleTime'],
        '4': ['actualSortingQuantity', 'pickupOrderNumber', 'despatchTime', 'storageTime']
      };
      hideKeyList = obj[val] || [];
      newColumns = columns.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
      v.tableColumns = newColumns;
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    // 监听tab栏切换
    'orderTableStatus': {
      handler(value) {
        // 出库状态
        this.deliveryOrderStatusList = [];
        this.dropDownTimeList = [];
        this.handleColumns(value);
        this.deliveryOrderStatusData = [
          {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001808')},
          {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001809')},
          {value: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001810')},
          {value: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003693')},
          {value: 7, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003696')},
          {value: 8, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004130')},
        ];
        // 时间
        let timeList = [
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'), value: 1, parameterKey: ['startCreatedTime', 'endCreatedTime']},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004565'), value: 2, parameterKey: ['startDespatchTime', 'endDespatchTime']},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'), value: 3, parameterKey: ['startStorageTime', 'endStorageTime']},
          {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004566'), value: 4, parameterKey: ['startCancleTime', 'endCancleTime']},
        ];
        // 1:待发货 2:已发货 21:已入库 3:已分拣(YMS已收货) 4:已取消
        let values = {
          statusObj: {
            '0': [1, 2, 3, 4, 5, 7, 8],
            '1': [1, 2, 3],
            '2': [4, 8]
          },
          timeObj: {
            '0': [1, 2, 3, 4],
            '1': [1],
            '2': [1, 2],
            '21': [1, 2, 3],
            '3': [1, 2, 3],
            '4': [1, 4]
          }
        };
        this.deliveryOrderStatusData.map((item) => {
          if (values.statusObj[value]) {
            if (values.statusObj[value].includes(item.value)) {
              this.deliveryOrderStatusList.push(item);
            }
          }
        });
        timeList.map((item) => {
          if (values.timeObj[value]) {
            if (values.timeObj[value].includes(item.value)) {
              this.dropDownTimeList.push(item);
            }
          }
        });
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    dropDownDateTime,
    dropDownFilter,
    exportFieldsModal
  }
};
</script>

<style scoped>

</style>
